document.addEventListener('DOMContentLoaded', function() {
  // 获取所有hero banner组件
  const heroBanners = document.querySelectorAll('.joe-hero-banner');
  
  heroBanners.forEach(banner => {
    // 获取设置值
    const contentAlignment = banner.dataset.contentAlignment || 'center';
    const contentVertical = banner.dataset.contentVertical || 'center';
    const overlayColor = banner.dataset.overlayColor || '#000000';
    
    // 应用内容位置
    const content = banner.querySelector('.joe-hero-banner__content');
    const textContent = banner.querySelector('.joe-hero-banner__text-content');
    
    if (content) {
      // 水平对齐
      if (contentAlignment === 'left') {
        content.classList.add('joe-hero-banner__content--left');
        textContent.classList.add('joe-hero-banner__text-content--left');
      } else if (contentAlignment === 'right') {
        content.classList.add('joe-hero-banner__content--right');
        textContent.classList.add('joe-hero-banner__text-content--right');
      }
      
      // 垂直对齐
      if (contentVertical === 'top') {
        content.classList.add('joe-hero-banner__content--top');
      } else if (contentVertical === 'bottom') {
        content.classList.add('joe-hero-banner__content--bottom');
      }
    }
    
    // 应用遮罩层颜色
    const overlay = banner.querySelector('.joe-hero-banner__overlay');
    if (overlay) {
      overlay.style.backgroundColor = overlayColor;
    }
    
    // 设置banner高度
    const desktopImage = banner.querySelector('.joe-hero-banner__image--desktop');
    const mobileImage = banner.querySelector('.joe-hero-banner__image--mobile');
    const desktopVideo = banner.querySelector('.joe-hero-banner__video--desktop');
    const mobileVideo = banner.querySelector('.joe-hero-banner__video--mobile');
    
    function setBannerHeight() {
      if (window.innerWidth > 768) {
        // 桌面端：根据媒体比例设置高度
        if (desktopVideo && desktopVideo.videoWidth > 0 && desktopVideo.videoHeight > 0) {
          // 视频元素
          const aspectRatio = desktopVideo.videoHeight / desktopVideo.videoWidth;
          const height = window.innerWidth * aspectRatio;
          const viewportH = Math.max(window.innerHeight, document.documentElement.clientHeight || 0);
          banner.style.height = `${Math.max(height, viewportH)}px`;
        } else if (desktopImage && desktopImage.naturalWidth > 0 && desktopImage.naturalHeight > 0) {
          // 图片元素
          const aspectRatio = desktopImage.naturalHeight / desktopImage.naturalWidth;
          const height = window.innerWidth * aspectRatio;
          const viewportH = Math.max(window.innerHeight, document.documentElement.clientHeight || 0);
          banner.style.height = `${Math.max(height, viewportH)}px`;
        } else if (desktopImage) {
          // 如果图片还没加载完成，使用图片的显示尺寸或等待加载
          if (desktopImage.offsetWidth > 0 && desktopImage.offsetHeight > 0) {
            const aspectRatio = desktopImage.offsetHeight / desktopImage.offsetWidth;
            const height = window.innerWidth * aspectRatio;
            const viewportH = Math.max(window.innerHeight, document.documentElement.clientHeight || 0);
            banner.style.height = `${Math.max(height, viewportH)}px`;
          }
        }
      } else {
        // 移动端：根据媒体比例设置高度
        if (mobileVideo && mobileVideo.videoWidth > 0 && mobileVideo.videoHeight > 0) {
          // 视频元素
          const aspectRatio = mobileVideo.videoHeight / mobileVideo.videoWidth;
          const height = window.innerWidth * aspectRatio;
          const viewportH = Math.max(window.innerHeight, document.documentElement.clientHeight || 0);
          banner.style.height = `${Math.max(height, viewportH)}px`;
        } else if (mobileImage && mobileImage.naturalWidth > 0 && mobileImage.naturalHeight > 0) {
          // 图片元素
          const aspectRatio = mobileImage.naturalHeight / mobileImage.naturalWidth;
          const height = window.innerWidth * aspectRatio;
          const viewportH = Math.max(window.innerHeight, document.documentElement.clientHeight || 0);
          banner.style.height = `${Math.max(height, viewportH)}px`;
        } else if (mobileImage) {
          // 如果图片还没加载完成，使用图片的显示尺寸
          if (mobileImage.offsetWidth > 0 && mobileImage.offsetHeight > 0) {
            const aspectRatio = mobileImage.offsetHeight / mobileImage.offsetWidth;
            const height = window.innerWidth * aspectRatio;
            const viewportH = Math.max(window.innerHeight, document.documentElement.clientHeight || 0);
            banner.style.height = `${Math.max(height, viewportH)}px`;
          }
        }
      }
      
      // 强制刷新遮罩层显示
      if (overlay) {
        overlay.style.display = 'none';
        overlay.offsetHeight; // 强制重排
        overlay.style.display = 'block';
      }
    }
    
    // 初始化高度
    const mediaElements = [];
    
    // 收集所有媒体元素
    if (desktopImage) mediaElements.push(desktopImage);
    if (mobileImage) mediaElements.push(mobileImage);
    if (desktopVideo) mediaElements.push(desktopVideo);
    if (mobileVideo) mediaElements.push(mobileVideo);
    
    if (mediaElements.length > 0) {
      // 等待媒体加载完成后设置高度
      Promise.all(
        mediaElements.map(element => {
          return new Promise(resolve => {
            if (element.tagName === 'VIDEO') {
              // 视频元素
              if (element.readyState >= 1) {
                resolve();
              } else {
                element.addEventListener('loadedmetadata', resolve);
              }
            } else {
              // 图片元素
              if (element.complete) {
                resolve();
              } else {
                element.addEventListener('load', resolve);
              }
            }
          });
        })
      ).then(() => {
        setBannerHeight();
        // 图片加载完成后再次检查高度，确保准确
        if (desktopImage) {
          desktopImage.addEventListener('load', () => {
            setBannerHeight();
          });
        }
        if (mobileImage) {
          mobileImage.addEventListener('load', () => {
            setBannerHeight();
          });
        }
      });
    } else {
      // 如果没有媒体元素，设置默认高度
      banner.style.height = '600px';
    }
    
    // 视频初始化设置
    const videos = banner.querySelectorAll('video');
    videos.forEach(video => {
      // 确保视频最初是暂停的，且设置了必要属性
      video.pause();
      video.muted = true;
      video.playsInline = true;
      video.loop = true;
      
      // 视频加载元数据后重新计算高度
      video.addEventListener('loadedmetadata', setBannerHeight);
      
      // 视频错误处理
      video.addEventListener('error', (e) => {
        console.error('视频播放错误:', e);
      });
    });

    // 点击播放按钮处理 - 新增代码
    const playButton = banner.querySelector('.joe-hero-banner__text-display');
    const bannerContent = banner.querySelector('.joe-hero-banner__content');
    
    if (playButton && videos.length > 0) {
      let isPlaying = false;
      
      // 添加点击事件监听器 - 修改为切换播放/暂停功能
      playButton.addEventListener('click', function() {
        // 判断当前是否正在播放
        if (isPlaying) {
          // 如果正在播放，则暂停
          pauseVideos();
          showContent();
          isPlaying = false;
        } else {
          // 如果未播放，则播放
          playVideos();
        }
      });
      
      // 在组件上添加一个点击事件，用于点击视频区域时暂停
      banner.addEventListener('click', function(e) {
        // 只有当点击的不是播放按钮或按钮内部元素时，才处理点击事件
        if (isPlaying && !playButton.contains(e.target) && !e.target.closest('.joe-hero-banner__button')) {
          pauseVideos();
          showContent();
          isPlaying = false;
        }
      });
      
      // 封装播放视频的函数
      function playVideos() {
        if (isPlaying) return; // 防止重复播放
        
        videos.forEach(video => {
          const isMobile = window.innerWidth <= 768;
          if ((isMobile && video.classList.contains('joe-hero-banner__video--mobile')) || 
              (!isMobile && video.classList.contains('joe-hero-banner__video--desktop'))) {
            
            // 取消静音
            video.muted = false;
            
            // 播放视频
            const playPromise = video.play();
            
            if (playPromise !== undefined) {
              playPromise.then(() => {
                // 视频成功播放
                isPlaying = true;
                hideContent();
              }).catch(error => {
                console.error('视频播放失败:', error);
                
                // 尝试静音播放（解决移动端自动播放限制）
                video.muted = true;
                video.play().then(() => {
                  isPlaying = true;
                  hideContent();
                }).catch(err => {
                  console.error('静音播放也失败:', err);
                });
              });
            }
          }
        });
      }
      
      // 封装暂停视频的函数
      function pauseVideos() {
        videos.forEach(video => {
          video.pause();
        });
      }
      
      // 封装隐藏内容的函数
      function hideContent() {
        if (bannerContent) {
          // 设置CSS过渡
          bannerContent.style.transition = 'opacity .6s ease-out';
          // 设置透明度为0来淡出
          bannerContent.style.opacity = '0';
          
          // 隐藏播放按钮
          playButton.style.opacity = '0';
          playButton.style.transition = 'opacity 0.5s ease-out';
          
          // 一段时间后隐藏播放按钮并禁用点击
          setTimeout(() => {
            playButton.style.pointerEvents = 'none';
          }, 500);
        }
      }
      
      // 封装显示内容的函数
      function showContent() {
        if (bannerContent) {
          bannerContent.style.transition = 'opacity 1s ease-in';
          bannerContent.style.opacity = '1';
          
          playButton.style.opacity = '1';
          playButton.style.transition = 'opacity 0.5s ease-in';
          playButton.style.pointerEvents = 'auto';
        }
      }
      
      // 视频结束事件处理
      videos.forEach(video => {
        video.addEventListener('ended', function() {
          // 视频结束后重置状态
          isPlaying = false;
          showContent();
        });
      });
      
      // 新增：检测组件离开视口后自动停止视频
      if ('IntersectionObserver' in window) {
        const videoObserver = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            // 当组件完全离开视口时
            if (!entry.isIntersecting && isPlaying) {
              pauseVideos();
              showContent();
              isPlaying = false;
            }
          });
        }, {
          root: null, // 使用视口作为参考
          rootMargin: '0px',
          threshold: 0 // 当元素完全不可见时触发
        });
        
        // 观察banner元素
        videoObserver.observe(banner);
      }
    }
    
    // 图片懒加载优化
    const images = banner.querySelectorAll('img');
    images.forEach(img => {
      if ('IntersectionObserver' in window) {
        const imageObserver = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              const img = entry.target;
              img.src = img.dataset.src || img.src;
              img.classList.remove('lazy');
              imageObserver.unobserve(img);
            }
          });
        });
        
        imageObserver.observe(img);
      }
    });
    
    // 按钮点击动画增强
    const button = banner.querySelector('.joe-hero-banner__button');
    if (button) {
      button.addEventListener('click', function(e) {
        // 创建点击波纹效果
        const ripple = document.createElement('span');
        const rect = button.getBoundingClientRect();
        const size = Math.max(rect.width, rect.height);
        const x = e.clientX - rect.left - size / 2;
        const y = e.clientY - rect.top - size / 2;
        
        ripple.style.cssText = `
          position: absolute;
          width: ${size}px;
          height: ${size}px;
          left: ${x}px;
          top: ${y}px;
          background: rgba(255, 255, 255, 0.3);
          border-radius: 50%;
          transform: scale(0);
          animation: ripple 0.6s linear;
          pointer-events: none;
        `;
        
        button.appendChild(ripple);
        
        // 动画结束后移除波纹元素
        setTimeout(() => {
          ripple.remove();
        }, 600);
      });
    }
    
    // 窗口大小改变时重新计算高度
    window.addEventListener('resize', setBannerHeight);
  });
});

// 添加波纹动画CSS
const style = document.createElement('style');
style.textContent = `
  @keyframes ripple {
    to {
      transform: scale(4);
      opacity: 0;
    }
  }
  
  /* 为播放按钮添加悬停效果 */
  .joe-hero-banner__text-display {
    cursor: pointer;
    transition: transform 0.3s ease, opacity 0.5s ease-out;
  }
  
  .joe-hero-banner__text-display:hover {
    transform: scale(1.1);
  }
  
  /* 改进内容淡出和淡入动画样式 */
  .joe-hero-banner__content {
    transition: opacity .6s ease-out;
  }
`;
document.head.appendChild(style);

// 性能优化：节流函数
function throttle(func, limit) {
  let inThrottle;
  return function() {
    const args = arguments;
    const context = this;
    if (!inThrottle) {
      func.apply(context, args);
      inThrottle = true;
      setTimeout(() => inThrottle = false, limit);
    }
  }
}

// 优化resize事件
const optimizedResize = throttle(() => {
  const heroBanners = document.querySelectorAll('.joe-hero-banner');
  heroBanners.forEach(banner => {
    const event = new Event('resize');
    banner.dispatchEvent(event);
  });
}, 100);

window.addEventListener('resize', optimizedResize);